<template>
	<ui-modal @toggle="emit('toggle')">
		<Head title="Liste des FAE" />
		<ui-title textSize="big" textPosition="left" class="lg:col-span-2 text-slate-700">
			<template v-slot:text>
				<p>Liste des FAE</p>
			</template>
		</ui-title>

		<div class="flex justify-between items-center mb-4">
			<h3 class="text-xl font-bold">Contrats</h3>
		</div>
		<div class="grid">
			<div class="grid grid-cols-3 gap-2 font-bold border-b">
				<div>Date de début</div>
				<div>Date de fin</div>
				<div>Prescripteur</div>
			</div>
			<div class="grid">
				<div v-for="contrat in contrats" class="grid grid-cols-3 gap-2 p-2 odd:bg-white even:bg-gray-100">
					<div>
						<span
							v-if="!contrat.date_end"
							:class="{
								'bg-gradient-green-low text-white': actualDate - new Date(contrat.date_at) < 2592000000 * 12 /* moins de 12 mois*/,
								'bg-gradient-red-low text-white':
									actualDate - new Date(contrat.date_at) < 2592000000 * 24 &&
									actualDate - new Date(contrat.date_at) > 2592000000 * 12 /* moins de 18 mois*/,
								'bg-gray-400 text-white': actualDate - new Date(contrat.date_at) > 2592000000 * 24 /* plus de 24 mois*/,
							}"
							class="px-2 py-1 rounded">
							{{ new Date(contrat.date_at).toLocaleDateString() }}
						</span>
						<span v-else>{{ new Date(contrat.date_at).toLocaleDateString() }}</span>
					</div>
					<div>
						<span
							v-if="contrat.date_end"
							:class="{
								'bg-gradient-green-low text-white': actualDate - new Date(contrat.date_end) < 2592000000 * 12 /* moins de 12 mois*/,
								'bg-gradient-red-low text-white':
									actualDate - new Date(contrat.date_end) < 2592000000 * 24 &&
									actualDate - new Date(contrat.date_end) > 2592000000 * 12 /* moins de 18 mois*/,
								'bg-gray-400 text-white': actualDate - new Date(contrat.date_end) > 2592000000 * 24 /* plus de 24 mois*/,
							}"
							class="px-2 py-1 rounded">
							{{ new Date(contrat.date_end).toLocaleDateString() }}
						</span>
						<span v-else>{{ contrat.date_end ? new Date(contrat.date_end).toLocaleDateString() : '-' }}</span>
					</div>
					<div>
						{{ contrat.contact.first_name }} {{ contrat.contact.last_name }}
						<span v-if="contrat.contact.targeted" class="rounded text-blue-500 p-1">
							<i class="fas fa-crosshairs"></i>
						</span>
					</div>
				</div>
			</div>
		</div>
	</ui-modal>
</template>

<script setup>
	const props = defineProps({
		contrats: {
			type: Object,
			default: null,
		},
	});

	const actualDate = new Date();

	const emit = defineEmits(['toggle']);
</script>
